import { StaticLayout } from './static-layout'

export function ReleaseNotesPage() {
  return (
    <StaticLayout title="Release notes" description="What changed and when.">
      <h2>2026-05-13 — Full stack rewrite</h2>
      <ul>
        <li>Frontend migrated from Next.js to Vite + React + TanStack Router/Query.</li>
        <li>
          Authentication moved from bearer tokens in <code>localStorage</code> to httpOnly
          session cookies (Laravel Sanctum SPA mode) with CSRF.
        </li>
        <li>
          Hocuspocus WebSocket server now verifies access via the API on every connection
          (<code>/v1/documents/&#123;id&#125;/can-access</code>), using a shared internal token.
        </li>
        <li>
          Markdown rendering hardened: <code>rehype-raw</code> removed, sanitize schema tightened
          (no <code>&lt;script&gt;</code>, <code>&lt;iframe&gt;</code>, JS-protocol URLs, etc.).
        </li>
        <li>
          Editor split into focused hooks (<code>useCollaborativeEditor</code>,
          <code>useDocumentSave</code>) and components.
        </li>
        <li>PDF export and Puppeteer dependency removed.</li>
        <li>Pricing pages removed — the product is free.</li>
      </ul>

      <h2>Earlier</h2>
      <p>
        Older changes were not tracked publicly. From this release we&apos;ll record meaningful
        changes here.
      </p>
    </StaticLayout>
  )
}
